import { ClientLoadModel } from '@numeo/types-core'

export const getLoadDetail = (load: ClientLoadModel, detailName: string) => {
    const emailDetails = load.emailHistory?.details as Record<string, unknown> | undefined
    if (emailDetails?.[detailName]) {
        return emailDetails[detailName]
    }

    const callHistory = load.callHistory || []
    for (let i = callHistory.length - 1; i >= 0; i--) {
        const callDetails = callHistory[i].details as Record<string, unknown> | undefined
        if (callDetails?.[detailName]) {
            return callDetails[detailName]
        }
    }
}

export const getInfoRequestVoiceAgentLoad = (load: ClientLoadModel) => ({
    referenceId: load.postersReferenceId,
    loadId: load._id,
    origin: {
        city: load.origin.city,
        stateProv: load.origin.stateProv,
    },
    destination: {
        city: load.destination.city,
        stateProv: load.destination.stateProv,
    },
    equipmentType: load.equipmentType,
    earliestAvailability: load.earliestAvailability,
    latestAvailability: load.latestAvailability,
    comments: load.comments,
    rate: load.rateInfo?.rateUsd,
    weight: load.shipmentDetails?.maximumWeightPounds || getLoadDetail(load, 'weight'),
    specialNotes: getLoadDetail(load, 'specialNotes'),
    pickup: getLoadDetail(load, 'pickupDateTime'),
    delivery: getLoadDetail(load, 'deliveryDateTime'),
    commodity: getLoadDetail(load, 'commodity'),
})
